import { message } from "antd";
import axios, { InternalAxiosRequestConfig } from "axios";

import { autJobServiceQueryTokenKey, loginTokenKey } from "../constants";

axios.interceptors.request.use(
	(config: InternalAxiosRequestConfig) => {
		config.headers["Content-Type"] = "application/json";
		config.headers["Access-Control-Allow-Origin"] = "*";
		config.headers["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept";

		const autJobServiceQueryToken = localStorage.getItem(autJobServiceQueryTokenKey);
		const token = localStorage.getItem(loginTokenKey);
		const tokenToSend = autJobServiceQueryToken || token;

		if (tokenToSend) {
			config.headers.Authorization = `Bearer ${tokenToSend}`;
		}

		if (autJobServiceQueryToken) {
			config.baseURL = process.env.REACT_APP_JOB_SERVICE_BASE_URL;
		} else {
			config.baseURL = process.env.REACT_APP_API_HOST;
		}

		return config;
	},
	(error) => Promise.reject(error)
);

axios.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response?.status === 401) {
			message.error({ content: "User not unauthorized!", key: "unauthorized", duration: 2 });
			localStorage.clear();
			// window.location("/");
		}
		throw error;
	}
);
